import { directusApi } from '@/api';
import { Data } from '@/models/data.model';
import { asyncForEach } from '@/utils';
import lodash, { xor } from 'lodash';
export interface Surtido {
    id?: number;
    slug: string;
    name: string;
}

export interface SurtidoState {
    allSurtido: Array<Surtido>;
    allSurtidoLoading: boolean;

    activeSurtido: any | null;
    activeSurtidoLoading: boolean;

    dataPerPage: number;
    dataPage: number;
    dataTotal: number;
}

const state: SurtidoState = {
    allSurtido: [],
    allSurtidoLoading: false,

    activeSurtido: null,
    activeSurtidoLoading: false,
    dataPerPage: 1,
    dataPage: 1,
    dataTotal: 1,
};

const defaultSurtido = {
    id: 0,
    slug: '',
    name: ''
}

const mutations = {
    TOGGLE_ALL_SURTIDO_LOADING(state: SurtidoState, data: boolean) {
        state.allSurtidoLoading = data;
    },
    SET_ALL_SURTIDO(state: SurtidoState, data: any) {
        // console.log(data);
        state.allSurtido = data;
        state.dataPerPage = data.meta.limit;
        state.dataPage = data.meta.page;
        state.dataTotal = data.meta.total;

    },
    TOGGLE_ACTIVE_SURTIDO_LOADING(state: SurtidoState, data: boolean) {
        state.activeSurtidoLoading = data;
    },
    REMOVE_SURTIDO(state: SurtidoState, id: number) {
        state.allSurtido = lodash.remove(state.allSurtido, function (n) {
            return n.id != id;
        });
    },
    SET_ACTIVE_SURTIDO(state: SurtidoState, data: any) {
        // data.articulos = {
        //     "OTROS": [
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A-1BD0",
        //             "renglonid": "1",
        //             "existencia": "280.0",
        //             "cantidadSeleccionada": 280
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A-2-2",
        //             "renglonid": "1",
        //             "existencia": "64.0",
        //             "cantidadSeleccionada": 64
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A2-2",
        //             "renglonid": "1",
        //             "existencia": "24.0",
        //             "cantidadSeleccionada": 24
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "B4-0",
        //             "renglonid": "1",
        //             "existencia": "51.0",
        //             "cantidadSeleccionada": 51
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "E3-3T2",
        //             "renglonid": "1",
        //             "existencia": "240.0",
        //             "cantidadSeleccionada": 240
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "E4-2T1",
        //             "renglonid": "1",
        //             "existencia": "64.0",
        //             "cantidadSeleccionada": 64
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "F1-2T2",
        //             "renglonid": "1",
        //             "existencia": "240.0",
        //             "cantidadSeleccionada": 240
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "F2-0T2",
        //             "renglonid": "1",
        //             "existencia": "84.0",
        //             "cantidadSeleccionada": 84
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "F4-2T2",
        //             "renglonid": "1",
        //             "existencia": "240.0",
        //             "cantidadSeleccionada": 240
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "F4-3T2",
        //             "renglonid": "1",
        //             "existencia": "240.0",
        //             "cantidadSeleccionada": 240
        //         },
        //         {
        //             "articulo": "C12N",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "313.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A-1BD0",
        //             "renglonid": "2",
        //             "existencia": "393.0",
        //             "cantidadSeleccionada": 393
        //         },
        //         {
        //             "articulo": "C12N",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "313.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A-2-2",
        //             "renglonid": "2",
        //             "existencia": "57.0",
        //             "cantidadSeleccionada": 57
        //         },
        //         {
        //             "articulo": "C12N",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "313.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A2-2",
        //             "renglonid": "2",
        //             "existencia": "59.0",
        //             "cantidadSeleccionada": 59
        //         },
        //         {
        //             "articulo": "C12N",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "313.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "B4-0",
        //             "renglonid": "2",
        //             "existencia": "53.0",
        //             "cantidadSeleccionada": 53
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A-2-2",
        //             "renglonid": "1",
        //             "existencia": "64.0",
        //             "cantidadSeleccionada": 64
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A2-2",
        //             "renglonid": "1",
        //             "existencia": "24.0",
        //             "cantidadSeleccionada": 24
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "B4-0",
        //             "renglonid": "1",
        //             "existencia": "51.0",
        //             "cantidadSeleccionada": 51
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "E3-3T2",
        //             "renglonid": "1",
        //             "existencia": "240.0",
        //             "cantidadSeleccionada": 240
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "E4-2T1",
        //             "renglonid": "1",
        //             "existencia": "64.0",
        //             "cantidadSeleccionada": 64
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "F1-2T2",
        //             "renglonid": "1",
        //             "existencia": "240.0",
        //             "cantidadSeleccionada": 240
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "F2-0T2",
        //             "renglonid": "1",
        //             "existencia": "84.0",
        //             "cantidadSeleccionada": 84
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "F4-2T2",
        //             "renglonid": "1",
        //             "existencia": "240.0",
        //             "cantidadSeleccionada": 240
        //         },
        //         {
        //             "articulo": "C12R",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "239.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "F4-3T2",
        //             "renglonid": "1",
        //             "existencia": "240.0",
        //             "cantidadSeleccionada": 240
        //         },
        //         {
        //             "articulo": "C12N",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "313.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A-1BD0",
        //             "renglonid": "2",
        //             "existencia": "393.0",
        //             "cantidadSeleccionada": 393
        //         },
        //         {
        //             "articulo": "C12N",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "313.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A-2-2",
        //             "renglonid": "2",
        //             "existencia": "57.0",
        //             "cantidadSeleccionada": 57
        //         },
        //         {
        //             "articulo": "C12N",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "313.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "A2-2",
        //             "renglonid": "2",
        //             "existencia": "59.0",
        //             "cantidadSeleccionada": 59
        //         },
        //         {
        //             "articulo": "C12N",
        //             "unidad": "RO",
        //             "precio": "1008.29",
        //             "cantidad": "1.0",
        //             "cantidadpendiente": null,
        //             "disponible": "313.0",
        //             "preciototal": "1008.29",
        //             "descripcionextra": null,
        //             "ubicacion": "B4-0",
        //             "renglonid": "2",
        //             "existencia": "53.0",
        //             "cantidadSeleccionada": 53
        //         }
        //     ]
        // }; PRUEBAS PARA CHECAR UN TICKET LARGO
        state.activeSurtido = data;
    }
};

const actions = {
    async getOne({ _, commit }: any, data: any | null = null) {
        try {
            // console.log(data);
            commit('SET_ACTIVE_SURTIDO', data);
            commit('TOGGLE_ACTIVE_SURTIDO_LOADING', false);
        } catch (error) {
            console.log(error);
            commit('TOGGLE_ACTIVE_SURTIDO_LOADING', false);
        }
    },
    async getAll({ _, commit }: any, { search, page, user }: any) {
        commit('TOGGLE_ALL_SURTIDO_LOADING', true);
        let params = {};
        if (search) {
            search = search.toUpperCase();
            params = { ...params, search };
        }
        // if (search) params = { ...params, search }
        if (page) params = { ...params, page };
        params = { ...params };
        let query = new URLSearchParams(params);

        let endpoint = `custom/legacy-intelisis/surtido/info?${query}`;
        let user_level = user.level;

        await directusApi('GET', endpoint)
            .then(async res => {
                // console.log({ res });
                let format_data = res.data;
                let format_articles = [];
                let resultado = [];

                await asyncForEach(format_data.data, async (item: any) => {
                    // ******* INICIO Formateando fecha para mostrarla de forma amigable al usuario
                    let simple_date = new Date(item.fecharegistro);
                    // Obtener el día, mes y año
                    const dia = String(simple_date.getDate()).padStart(2, '0');
                    const mes = String(simple_date.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
                    const año = simple_date.getFullYear();

                    // Formatear la fecha
                    item.fecha = `${dia}/${mes}/${año}`;


                    const date = new Date(item.fecharegistro.replace(" ", "T")); // Convertir a formato válido  
                    const formattedDate = date.toLocaleString("es-ES", {
                        weekday: "long", // Martes  
                        day: "2-digit",
                        month: "long", // Marzo  
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true, // Formato 12h con AM/PM  
                    });
                    item.fecharegistro = formattedDate;
                    // ******* FIN Formateando fecha para mostrarla de forma amigable al usuario

                    // ******* INICIO Filtro de disponibilidad por ubicación
                    format_articles = filterByAvailability(item.articulos);
                    // ******* FIN Filtro de disponibilidad por ubicación

                    // ******* INICIO Agrupar por niveles
                    format_articles = levelGroup(format_articles);
                    // ******* FIN Agrupar por niveles

                    // Llamar a la función y mostrar el resultado
                    resultado = agregarSinstock(item.articulos, format_articles);
                    item.articulos = resultado;
                });

                // cleaning data by level
                // const filter_data = format_data.data.filter((item: any) => {
                //     // Si user_level está vacío o no definido, no aplicamos el filtro
                //     if (!user_level) {
                //         return true; // No se aplica ningún filtro, devuelve todos los elementos
                //     }

                //     // Si el user_level es '1-2', validamos con 1 y 2
                //     if (user_level === '1-2') {
                //         return item.articulos.hasOwnProperty('1') || item.articulos.hasOwnProperty('2');
                //     }

                //     // Para otros casos, validamos si existe la clave correspondiente al user_level
                //     return item.articulos.hasOwnProperty(user_level);
                // });
                // // console.log(res.data);
                // res.data.data = filter_data;
                // **********************
                commit('SET_ALL_SURTIDO', res.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_SURTIDO_LOADING', false);
            });
    },
};

//Funcionando todo lo de abajo------------------------------------------
function groupByRenglonID(data: any) {
    if (!Array.isArray(data)) {
        console.error("Error: data no es un array en groupByRenglonID", data);
        return {};
    }
    return data.reduce((acc: any, item: any) => {
        if (!acc[item.renglonid]) {
            acc[item.renglonid] = [];
        }
        acc[item.renglonid].push(item);
        return acc;
    }, {});
}

function groupByLocation(data: any) {
    if (!Array.isArray(data)) {
        console.error("Error: data no es un array en groupByLocation", data);
        return {};
    }
    return data.reduce((acc: any, item: any) => {
        const firstChar = item.ubicacion.charAt(0);
        const groupKey = /^[0-9]/.test(firstChar) ? firstChar : "sin asignacion";

        if (!acc[groupKey]) {
            acc[groupKey] = [];
        }

        acc[groupKey].push(item);
        return acc;
    }, {});
}

function filterByAvailability(data: any) {
    if (!Array.isArray(data)) {
        console.error("Error: data no es un array en filterByAvailability", data);
        return [];
    }
    const groupedByRenglon = groupByRenglonID(data);

    let finalSelection = [];

    for (const renglonid in groupedByRenglon) {
        const groupedData = groupByLocation(groupedByRenglon[renglonid]);

        const sortedKeys = Object.keys(groupedData).sort((a: any, b: any) => {
            if (a === "sin asignacion") return 1;
            if (b === "sin asignacion") return -1;
            return a - b;
        });

        let remainingQuantity = parseFloat(groupedByRenglon[renglonid][0].cantidadpendiente);
        let selectedItems = [];
        let totalExistencia = 0;

        for (const key of sortedKeys) {
            for (const item of groupedData[key]) {
                const existencia = item.existencia ? parseFloat(item.existencia) : 0;
                totalExistencia += existencia;
                if (existencia > 0) {
                    if (remainingQuantity <= existencia) {
                        selectedItems.push({ ...item, cantidadSeleccionada: remainingQuantity });
                        remainingQuantity = 0;
                        break;
                    } else {
                        selectedItems.push({ ...item, cantidadSeleccionada: existencia });
                        remainingQuantity -= existencia;
                    }
                }
            }
            if (remainingQuantity <= 0) break;
        }

        if (totalExistencia < parseFloat(groupedByRenglon[renglonid][0].cantidadpendiente)) {
            selectedItems = selectedItems.map(item => ({ ...item, mensaje: "No hay existencias suficientes" }));
        }

        finalSelection = finalSelection.concat(selectedItems);
    }

    return finalSelection;
}

function levelGroup(data: any) {
    if (!Array.isArray(data)) {
        console.error("Error: data no es un array en levelGroup", data);
        return [];
    }
    const agrupados = data.reduce((acc, item) => {
        const ubicacion = item.ubicacion;
        let grupo;

        if (ubicacion && !isNaN(ubicacion[0])) {
            grupo = ubicacion[0]; // Tomar el primer dígito como clave
        } else {
            grupo = "OTROS"; // Agrupar las ubicaciones que no empiezan con un número
        }

        if (!acc[grupo]) {
            acc[grupo] = [];
        }
        acc[grupo].push(item);

        return acc;
    }, {});
    return agrupados;
}

function agregarSinstock(info_data, output_data) {
    // Crear un conjunto con los artículos que ya están en la salida
    let articulosEnSalida = new Set();
    for (let key in output_data) {
        output_data[key].forEach(item => {
            articulosEnSalida.add(item.articulo);
        });
    }

    // Filtrar los artículos que no están en la salida
    let articulosSinstock = info_data.filter(item => !articulosEnSalida.has(item.articulo));

    // Crear un objeto para almacenar registros únicos basados en el campo "articulo"
    let registrosUnicos = {};

    // Recorrer los artículos filtrados y asegurarse de que sean únicos
    articulosSinstock.forEach(item => {
        if (!registrosUnicos[item.articulo]) {
            registrosUnicos[item.articulo] = {
                ...item,
                cantidadSeleccionada: parseFloat(item.cantidadpendiente)
            };
        }
    });

    // Convertir el objeto de registros únicos a un array
    let registrosUnicosArray = Object.values(registrosUnicos);

    // Agregar el nuevo segmento "SINSTOCK" con los registros únicos
    output_data["SINSTOCK"] = registrosUnicosArray;

    return output_data;
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
